(function () {
  'use strict';
  if (window.__bayintAnalytics || !/^(www\.)?bayintmed\.com$/.test(location.hostname)) return;
  window.__bayintAnalytics = true;
  var measurementId = 'G-LX074RSNWE', started = false;
  var clarityStarted = false;
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'default', {analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  function allowed() { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); }
  var pendingKey = 'bayint_pending_enquiry', formStarts = {};
  function contactForm(node) {
    var form = node && node.closest && node.closest('form');
    return form && form.id && form.querySelector('input[name="form_type"][value="contact"]') ? form : null;
  }
  function reportLead() {
    if (!started || !allowed()) return;
    try {
      var pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending) return;
      if (Date.now() - pending.at > 1800000) { sessionStorage.removeItem(pendingKey); return; }
      var form = document.getElementById(pending.formId);
      if (pending.path !== location.pathname || !form || !form.querySelector('[data-bayint-lead-success]')) return;
      sessionStorage.removeItem(pendingKey);
      window.gtag('event', 'generate_lead', {form_id:pending.formId,send_to:measurementId});
      window.clarity('event', 'enquiry_success');
    } catch (error) { /* Storage unavailable: do not infer a lead. */ }
  }
  function update() {
    var consent = allowed();
    window.clarity('consentv2', {analytics_Storage:consent?'granted':'denied',ad_Storage:'denied'});
    if (consent && !clarityStarted) {
      clarityStarted = true;
      var clarityScript = document.createElement('script');
      clarityScript.async = true;
      clarityScript.src = 'https://www.clarity.ms/tag/ywfj37vnm2';
      document.head.appendChild(clarityScript);
    }
    window['ga-disable-' + measurementId] = !consent;
    window.gtag('consent', 'update', {analytics_storage:consent?'granted':'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    if (!consent) { try { sessionStorage.removeItem(pendingKey); } catch (error) {} return; }
    if (started) { reportLead(); return; }
    started = true;
    window.gtag('js', new Date());
    var safeUrl = new URL(location.origin + location.pathname), query = new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){if(query.has(k)) safeUrl.searchParams.set(k,query.get(k));});
    window.gtag('config', measurementId, {page_location:safeUrl.href,allow_google_signals:false,allow_ad_personalization_signals:false});
    var script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+measurementId;document.head.appendChild(script);
    reportLead();
  }
  document.addEventListener('DOMContentLoaded', reportLead);
  document.addEventListener('focusin', function(event) {
    var form = contactForm(event.target);
    if (!started || !allowed() || !form || formStarts[form.id]) return;
    formStarts[form.id] = true;
    window.gtag('event', 'enquiry_start', {form_id:form.id,send_to:measurementId});
  });
  document.addEventListener('submit', function(event) {
    var form = contactForm(event.target);
    if (!started || !allowed() || !form || event.defaultPrevented || !form.checkValidity()) return;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({formId:form.id,path:location.pathname,at:Date.now()})); } catch (error) {}
  });
  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('click', function(event){
    if (!started || !allowed()) return;
    var a=event.target.closest('a[href]');if(!a) return;
    var href=a.getAttribute('href'),method=/^mailto:/i.test(href)?'email':/^tel:/i.test(href)?'phone':null;
    if(method) window.gtag('event','contact_click',{contact_method:method,send_to:measurementId});
  });
  if (window.Shopify && Shopify.customerPrivacy) update();
  else if(window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)update();});
})();
